// RPECK21/11/2024 - Added to give us the means to use different JS on multiple pages
function loadValues() {

  // RPECK 03/09/2023 - Elements
  document.querySelectorAll(".rpeck_date").forEach(function(element) {

    // RPECK 03/09/2023 - Only proceed if the element is valid
    if(element && 'timestamp' in element.dataset) {

      // RPECK 03/09/2023 - Vars
      var data            = element.dataset;
      var days_element    = element.querySelector('.days');
      var hours_element   = element.querySelector('.hours');
      var minutes_element = element.querySelector('.minutes');
      var seconds_element = element.querySelector('.seconds');
      var countDownDate   = new Date(parseInt(data.year), parseInt(data.month) - 1, parseInt(data.day), parseInt(data.hour), parseInt(data.minute), parseInt(data.seconds));

      // Update the count down every 1 second
      var x = setInterval(function() {
      
      // Get today's date and time
      var now = new Date().getTime();
      
      // Find the distance between now and the count down date
      var distance = countDownDate - now;
      
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((distance % (1000 * 60)) / 1000);
      
      // Display the result in the element with id="demo"
      days_element.innerText    = ("00" + days).slice(-2);
      hours_element.innerText   = ("00" + hours).slice(-2);
      minutes_element.innerText = ("00" + minutes).slice(-2);
      seconds_element.innerText = ("00" + seconds).slice(-2);
        
        // If the count down is finished, write some text
        if (distance < 0) {
          clearInterval(x);
          element.innerHTML = "EXPIRED";
        }
      }, 1000);
      
    }
          
  });
  
}

if (document.readyState === "loading") {
  // Loading hasn't finished yet
  document.addEventListener("DOMContentLoaded", loadValues);
} else {
  // `DOMContentLoaded` has already fired
  loadValues();
}

/*
  RPECK 26/12/2024 - Updated predictive search using HTML rather than JSON 
  --------------------
*/
document.addEventListener('DOMContentLoaded', function(event) {

  // RPECK 26/12/2024 - Predictive Search
  let   timeout = '';
  const predictive_wrapper = document.getElementById('PredictiveWrapper');
  const predictive_results = document.getElementById('PredictiveResults');

  // RPECK 26/12/2024 - Bind to the search bar
  document.querySelector('.site-header__search-input')?.addEventListener('input', function(e) {

    // RPECK 26/12/2024 - Timeout
    clearTimeout(timeout), timeout = setTimeout(function() {

      // RPECK 26/12/2024 - Fetch the search endpoint using the code from the US site
      // https://auvodka.co.uk/search/suggest?q=marshmellow&resources[limit]=5&resources[limit_scope]=each&resources[options][unavailable_products]=last&section_id=predictive-search
      // --
      // Ref: ./assets/original-theme.js.liquid#2121  
      const url = new URL('/search/suggest', window.location.origin);
  
      url.searchParams.set('q', e.target.value.trim().replace(/\ /g, "-").toLowerCase());
      url.searchParams.set('resources[limit]', 8);
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      url.searchParams.set('section_id', 'predictive-search');
    
      fetch( decodeURIComponent(url.toString()) )
        .then((response) => {
          return response.text();
        })
        .then((text) => {
  
          // RPECK 26/12/2024 - Sanitize the markup
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
  
          // RPECK 26/12/2024 - Populate the results container with the markup
          predictive_results.innerHTML = resultsMarkup;
  
          // RPECK 26/12/2024 - Remove the 'hide' class
          predictive_wrapper.classList.remove('hide');
          
        })
        .catch((error) => {
          throw error; 
        });
      
    });

  }, 500);
  
});



document.addEventListener('DOMContentLoaded', function(event){

  // Vars
  var footer_buttons = document.querySelector('.app_buttons.mobile');
  var drawer         = document.querySelector('#NavDrawer .drawer__scrollable');

  // Proceed if footer buttons exists
  if (footer_buttons && drawer) {

    // Clone
    var clone = footer_buttons.cloneNode(true)
    clone.classList.add('appear-animation', 'appear-delay-7');

    // Append to the nav item
    if(clone) drawer.appendChild(clone);
    
  }
  
});

